import React, { useCallback, useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import { BsQuestionCircle } from "react-icons/bs";
import { useInView } from "react-intersection-observer";
import Error from "../../screen/Error/Error";
export default function AnalysisHeader({
  children,
  index,
  count,
  title,
  description,
}) {
  const control = useAnimation();
  const [ref, inView] = useInView();

  useEffect(() => {
    if (inView) {
      control.start("visible");
    } else {
      control.start("hidden");
    }
  }, [control, inView]);

  const exampleVariant = {
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.8 },
    },
    hidden: { opacity: 0, scale: 1 },
  };

  return (
    <>
      <motion.div
        animate={control}
        ref={ref}
        className="box"
        variants={exampleVariant}
      >
        <div className="flex flex-col items-start text-left m-4 justify-center bg-white border-2 rounded-lg w-full lg:min-w-[78rem] lg:max-w-[78rem] md:min-w-[47rem] md:max-w-[47rem]  break-words">
          <div className="bg-gray-50 w-full p-4">
            <div className="flex flex-wrap items-center text-left">
              <div className="text-black/60 flex items-center">
                <BsQuestionCircle className="mx-2 text-sm" />
                Soru {index + 1}
              </div>
              <div className="divider divider-horizontal mx-2" />
              <div className="text-black/60">Toplam {count} Cevap</div>
            </div>

            <div className="flex flex-col items-start w-full border-t-2 mt-4 ml-2">
              <div className="text-2xl text-black mt-2 break-words w-full">{title}</div>
              <div className="text-md mt-1 text-black/60 break-words w-full">
                {!!description ? description : "Açıklama bulunmamaktadır."}
              </div>
            </div>
          </div>


          <div className="flex justify-center items-center w-full">
            {children}
          </div>

        </div>
      </motion.div>
    </>
  );
}
